/* OsLinkStatusComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./OsLinkStatusRenderer");
const _ = require("lodash");

class IotOsLinkStatusComponent extends DefaultColumnComponent {
    constructor(entity, context) {
        super(entity);
        this._entity = entity;
        this._OsLinkStatus = _.get(entity, "linkStatus", "");
        this._context = context;
        this._linkStatusValues = this._context.linkStatusValues;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    async shutdown() {
        this._unregisterListeners();
        await this._renderer._shutdown();
        this._renderer = undefined;
        this._entity = undefined;
        this._OsLinkStatus = undefined;
        this._context = undefined;
        this._linkStatusValues = undefined;
        return Promise.resolve();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newOsLinkStatus) {
        this._OsLinkStatus = newOsLinkStatus;
        this.emit("OsLinkStatus", newOsLinkStatus);
    }

    getValue() {
        return this._OsLinkStatus;
    }

    getOsLinkStatus() {
        return this.getValue();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = IotOsLinkStatusComponent;
